import React from "react";
import { EVENT_STYLES, fmtDT, shortVal } from "@/lib/platform";

const MODULE_LABELS = {
  tasks: "Tasks", approvals: "Approvals", findings: "Findings", controls: "Controls", ropa: "RoPA",
  evidence: "Evidence", remediation: "Remediation", raci: "RACI", trend: "Trend", board_memo: "Board Memo",
  files: "Files", users: "Users", tenant_settings: "Org Settings", dashboard: "Dashboard", requests: "Rights Requests", vendors: "Vendor Register", retention: "Retention Manager",
};

export const AuditTimeline = ({ items = [], compact = false, testId = "audit-timeline" }) => {
  if (!items.length) {
    return <div className="text-xs text-slate-500 py-6 text-center" data-testid={`${testId}-empty`}>No activity recorded yet.</div>;
  }
  return (
    <ol className="relative" data-testid={testId}>
      <span className="absolute left-[5px] top-2 bottom-2 w-px bg-slate-200" aria-hidden />
      {items.map((e) => {
        const st = EVENT_STYLES[e.event_type] || EVENT_STYLES.record_updated;
        return (
          <li key={e.id} className="relative pl-6 pb-4 last:pb-0" data-testid={`audit-event-${e.id}`}>
            <span className={`absolute left-0 top-1.5 w-[11px] h-[11px] rounded-full ring-2 ring-white ${st.dot}`} />
            <div className="flex items-center gap-2 flex-wrap">
              <span className={`text-[12px] font-semibold ${st.text}`}>{e.event_label}</span>
              {!compact && (
                <span className="text-[10px] font-mono uppercase px-1.5 py-0.5 rounded bg-slate-100 text-slate-500">
                  {MODULE_LABELS[e.module] || e.module}
                </span>
              )}
              {!compact && e.object_label && (
                <span className="text-[11px] text-slate-600 font-mono truncate max-w-[260px]">{e.object_label}</span>
              )}
            </div>
            <div className="text-[11px] text-slate-500 mt-0.5">
              <span className="font-medium text-slate-700">{e.actor}</span> · {fmtDT(e.timestamp)}
              {!compact && <span className="ml-1 text-slate-400">· {e.object_type}</span>}
            </div>
            {(e.old_value || e.new_value) && (
              <div className="mt-1 text-[11px] font-mono leading-relaxed bg-slate-50 border border-slate-100 rounded px-2 py-1 break-words">
                {e.old_value != null && <div className="text-slate-400 line-through">{shortVal(e.old_value)}</div>}
                {e.new_value != null && <div className="text-slate-700">{shortVal(e.new_value)}</div>}
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
};
